export enum images_club {
  banner_club = "https://amatech-prd.azure-api.net/api/janus/files-management/ti/website/banner_club.webp/beautify",
  banner_club_mobile = "https://amatech-prd.azure-api.net/api/janus/files-management/ti/website/banner_club_mobile.webp/beautify"
}